import settings from './settings';
import axios from 'axios';

export async function disableStructureAccess(accessToken, structureAccessId) {
  return axios.post(settings.endpoints.disableStructureAccess(structureAccessId), {}, {
    headers: {
      Authorization: accessToken
    }
  });
}
